import * as RadixToggleGroup from '@radix-ui/react-toggle-group';
import { capitalize } from 'lodash';
import { memo, useCallback } from 'react';

import {
  isUpgradePlanModalBillingCycle,
  SUPPORTED_BILLING_CYCLES,
  type UpgradePlanModalBillingCycle,
} from '~/components/Modals/PlansModal/utils';

export type UpgradePlanModalBillingCycleToggleProps = {
  billingCycle: UpgradePlanModalBillingCycle;
  onBillingCycleChange: (billingCycle: UpgradePlanModalBillingCycle) => void;
};

export const UpgradePlanModalBillingCycleToggle = memo(
  ({ billingCycle, onBillingCycleChange }: UpgradePlanModalBillingCycleToggleProps) => {
    const handleValueChange = useCallback(
      (value: string) => {
        if (!isUpgradePlanModalBillingCycle(value)) {
          return;
        }

        onBillingCycleChange(value);
      },
      [onBillingCycleChange],
    );

    return (
      <div className="flex w-full flex-1 justify-center">
        <RadixToggleGroup.Root
          type="single"
          orientation="horizontal"
          className="flex h-8 w-max items-center gap-1 rounded-8 bg-gray-4 px-1"
          value={billingCycle}
          onValueChange={handleValueChange}
        >
          {SUPPORTED_BILLING_CYCLES.map((value) => (
            <RadixToggleGroup.Item
              key={value}
              value={value}
              className="flex h-6 items-center justify-center rounded-6 px-1.5 font-medium text-14 text-gray-10 outline-none transition-colors hover:bg-gray-6 hover:text-gray-12 focus-visible:ring-2 focus-visible:ring-blue-9 data-[state=on]:bg-gray-1 data-[state=on]:text-gray-12 data-[state=on]:hover:bg-gray-2 data-[state=on]:hover:text-gray-11"
            >
              {capitalize(value)}
            </RadixToggleGroup.Item>
          ))}
        </RadixToggleGroup.Root>
      </div>
    );
  },
);

UpgradePlanModalBillingCycleToggle.displayName = 'UpgradePlanModalBillingCycleToggle';
